<app-header [navItems]="navItems">
  <div subtitle>
    {{ 'connectionpoint.title' | translate }}
  </div>
  <div title>
    {{ address }}
  </div>
</app-header>

@if (connectionPoint?.address?.darReference && mapVisible) {
  <app-map [darReference]="connectionPoint!.address!.darReference"></app-map>
}

<div>
  <router-outlet></router-outlet>
</div>
